<template>
  <ss-modal
    v-show="isModalVisible"
    title="Title"
    intro="bounceIn"
    outro ="bounceOut">
    <!-- HEADER -->
    <div slot="modal-header">
      Podaj kwotę wpłaty
      <i class="close" @click="closeModal(false)"></i>
    </div>
    <!-- BODY -->
    <div slot="modal-body" class="text-center">
      <d-col md="6" offset-md="3">
        <ss-price-input
          :class="{ disabled : actionInProgress }"
          v-model="amount" />
      </d-col>
    </div>
    <!-- FOOTER -->
    <div slot="modal-footer">
      <d-button
        @click.prevent="closeModal(false)"
        :class="{ disabled : actionInProgress }"
        theme="danger">
        <i class="material-icons">close</i> Anuluj
      </d-button>
      <d-button
        @click.prevent="contractPaidSubmit"
        :class="{
          'ml-3': true,
          'isLoading': actionInProgress
        }"
        theme="success">
        <i class="material-icons">check</i> Potwierdź
      </d-button>
    </div>
</ss-modal>
</template>

<script>
import SsModal from '@/components/common/SsModal'
import SsPriceInput from '@/components/common/SsPriceInput';
import LarErrors from '@/helpers/Errors';

export default {
  name: 'PaidInstallmentModal',
  components: {
    SsModal,
    SsPriceInput,
    LarErrors
  },
  props: {
    amountProp: {
      default: 0,
      type: Number
    },
    isModalVisible: {
      default: false,
      type: Boolean
    },
    scheduleId: {
      required: true,
      type: Number
    },
    terminatedPaymentDate: {
      required: true,
      type: String
    }
  },
  watch: {
    isModalVisible (newValue) {
      if (newValue) {
        this.amount = this.amountProp;
      }
    }
  },
  data () {
    return {
      actionInProgress: false,
      lar_errors: LarErrors,
      amount: null
    }
  },
  mounted () {
    this.amount = this.amountProp;
  },
  methods: {
    contractPaidSubmit (force = 0) {
      this.actionInProgress = true;
      if (force !== 1) {
        force = 0;
      }
      axios.post('api/schedules/partial-payment', {
        schedule_id: this.scheduleId,
        paid_date: this.terminatedPaymentDate,
        amount: this.amount,
        force: force
      }).then(response => {
        this.actionInProgress = false;

        if (response.data.status === 0) {
          if (response.data.overpayment === 1) {
            Vue.swal({
              type: 'warning',
              title: response.data.message,
              showCancelButton: true,
              confirmButtonText: 'Tak',
              cancelButtonText: 'Anuluj',
              buttonsStyling: true
            }).then((answer) => {
              if (answer.value) {
                this.contractPaidSubmit(1);
              }
            });

            this.closeModal(false);
          }
          else {
            Vue.swal({
              type: 'error',
              title: response.data.message,
              showConfirmButton: true,
            }).then(() => {
              this.closeModal(true);
            });
          }
        } else {
          Vue.swal({
            type: 'success',
            title: 'Płatność została zapisana.',
            showConfirmButton: true,
          }).then(() => {
            this.closeModal(true);
          }).catch((error) => {
            LarErrors.record(error.response.data.errors);
            Vue.swal({
              type: 'warning',
              title: 'Wystąpił błąd',
              text: error.response.data.error ? error.response.data.error : 'Spróbuj ponownie później',
              showConfirmButton: true,
            });
          })
        }

        this.$eventHub.$emit('refresh-payments-history');
      }).catch((error) =>{
        this.actionInProgress = false;
        this.closeModal();
        Vue.swal({
          type: 'warning',
          title: 'Wystąpił błąd',
          text: error.response.data.error ? error.response.data.error : 'Spróbuj ponownie później',
          showConfirmButton: true,
        });
      })
    },
    closeModal (shouldReload = false) {
      if (shouldReload) {
        this.$bus.$emit('reload-contract');
      }
      this.$bus.$emit('paid-installment-close');
    }
  }
}
</script>
